import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BIDDING } = ANALYTICS_CATEGORIES;

const { LOAD } = SNOWPLOW_EVENTS;

interface TriggerBidAcceptedEventParams {
	id: string;
}

export const triggerBidAccepted = ({ id }: TriggerBidAcceptedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING,
		customData: {
			label: `${id}`,
		},
		name: `dlr_bid_accepted`,
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
